<template>
    <form @submit.prevent="submit()">
        <ContentOrLoading :style="!listaAbonados ? 'padding: 100px;' : ''">
            <div class="row" v-if="listaAbonados">
                <div class="col-12">
                    <div class="form-group mb-4">
                        <div class="custom-control custom-checkbox">
                            <input class="custom-control-input" type="checkbox" id="check_sale" v-model="listaAbonados.check_sale" @change="checkCambiado()"/>
                            <label class="custom-control-label text-uppercase h6" style="padding-top: 2px;" for="check_sale">Activar venta de abonados</label>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="imagen">Imagen:</label>
                        <p>
                            <small>
                                FORMATO: JPG
                            </small>
                        </p>
                        <template v-if="listaAbonados.imagen !== null">
                            <img :src="listaAbonados.imagen" style="max-height: 300px"/>
                            <br/>
                            <Button class="mt-1" @click="imagenBorrada()">Borrar</Button>
                        </template>
                        <template v-else>
                            <Dropzone
                                v-if="url"
                                :url="url"
                                @success="imagenSubida"
                            />
                        </template>
                        <span v-if="errores.imagen" class="error invalid-feedback" style="display: block">El campo imagen es obligatorio</span>
                    </div>
                    <div class="form-group">
                        <label for="nombre">Abonos</label>
                        <QuillEditor v-model="listaAbonados.texto_abonos"/>
                        <span v-if="errores.abonos" class="error invalid-feedback" style="display: block">El campo abonos es obligatorio</span>
                    </div>
                    <div class="form-group">
                        <label for="nombre">Precios</label>
                        <QuillEditor v-model="listaAbonados.texto_precios"/>
                        <span v-if="errores.precios" class="error invalid-feedback" style="display: block">El campo precios es obligatorio</span>
                    </div>
                </div>
                <div class="col-12 text-right mt-3">
                    <Button type="submit" name="button" :disabled="loading">CONTINUAR</Button>
                </div>
            </div>
        </ContentOrLoading>
    </form>
</template>
<script>
    import Dropzone from '@/components/common/Dropzone';
    import QuillEditor from "@/modules/ui/QuillEditor.vue";

    export default {
        props: ['listaAbonados'],
        data() {
            return {
                loading: false,
                url: this.config.API_BASE + '/upload/image?api_key=' + localStorage.getItem('token') + '&permisos=public',
                errores: {
                    imagen: false,
                    abonos: false,
                    precios: false
                }
            }
        },
        methods: {
            submit() {
                if (this.esValido()) {
                    this.crearAbonado();
                }
            },
            esValido() {
                if (!this.listaAbonados) {
                    return false;
                }

                this.errores = { imagen: false, abonos: false, precios: false };

                if (!this.listaAbonados.check_sale) {
                    return true;
                }

                this.errores.imagen = !this.listaAbonados.imagen;
                this.errores.abonos = this.esTextoVacio(this.listaAbonados.texto_abonos);
                this.errores.precios = this.esTextoVacio(this.listaAbonados.texto_precios);

                return !this.errores.imagen && !this.errores.abonos && !this.errores.precios;
            },
            esTextoVacio(html) {
                if (!html) {
                    return true;
                }
                const texto = html.replace(/<[^>]*>/g, '').replace(/&nbsp;/gi, '').trim();
                return texto === '';
            },
            checkCambiado() {
                if (!this.listaAbonados.check_sale) {
                    this.errores = { imagen: false, abonos: false, precios: false };
                }
            },
            crearAbonado() {
                this.$emit('terminado');
            },
            imagenBorrada() {
                this.listaAbonados.imagen = null
            },
            imagenSubida(file, response) {
                this.listaAbonados.imagen = 'https://storage.compralaentrada.com/' + response;
            }
        },
        components: {
            Dropzone, QuillEditor
        }
    }
</script>
